import RequestButton from '@app/Equipment/RequestButton'

export default function install(Vue) {
  Vue.component('equipment-request-button', RequestButton)
}
